import { Injectable, inject } from "@angular/core";
import { HttpRequestService } from "../../../../../shared/services/http-request/http-request.service";
import { API } from "../../../../../shared/constants/api-url";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { Store } from "@ngxs/store";
import { IInsuranceCompany } from "../models/insurance-company.model";
import { PatchPayerList } from "../../../../../shared/store/payer/payer.actions";
import { ICommonAPIResponse } from "../../../../../shared/models/common-models";
import { DataGridFilterCondition } from "../../../../../shared/constants/datagrid-filter-condition.enum";

@Injectable({
  providedIn: 'root'
})
export class PayerService {
  private store = inject(Store);
  private httpRequestService = inject(HttpRequestService);

  private payerListSubject = new BehaviorSubject<IInsuranceCompany[]>([]);
  payerList$ = this.payerListSubject.asObservable();

  getPayerListByIds(ids: string[]): Observable<unknown> {
    const payload = {
      columns: [
        {
          name: "companyId",
          searchable: true,
          orderable: true,
          filterable: true,
          filterSearch: {
            value: ids?.length === 1 ? ids[0] : ids?.join(','),
            condition: DataGridFilterCondition.IsEqualTo
          },
          excelColumnName: "companyId"
        }
      ],
      defaultSortingColumn: "companyId",
      pageNumber: 0,
      pageSize: 0,
      sortBy: "companyId",
      sortOrder: "asc",
      generalSearch: "",
      isSearchByCriteria: true
    };
    return this.httpRequestService.post(API.INSURANCE_COMPANY.GET_INSURANCE_LIST, payload);
  }

  setStorePayers(ids: string[]) {
    if (!ids || ids.length === 0) {
      this.updateStore(null);
      return;
    }
    this.getPayerListByIds(ids).pipe(
      tap((resp: ICommonAPIResponse<IInsuranceCompany>) => {
        resp && resp.results && this.updateStore(resp.results as IInsuranceCompany[]);
      })
    ).subscribe();
  }

  clearStore() {
    this.updateStore(null);
  }

  private updateStore(payers: IInsuranceCompany[] | null) {
    this.payerListSubject.next(payers);
    this.store.dispatch(new PatchPayerList(payers));
  }
}